<template>
  <v-tooltip
    v-if="!disabled"
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <avs-button
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
        fab
        iconI="mdi-grid"
        icon
        label
        small
        color="secondary"
        @click="handleClick"
      />
    </template>
    <span>{{ spantext }}</span>
  </v-tooltip>
  <avs-button
    v-else
    v-bind="$attrs"
    v-on="$listeners"
    icon
    iconI="mdi-grid-off"
    label
    fab
    small
    disabled
  />
</template>

<script>
export default {
  name: "GridButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    spantext: {
      type: String
    }
  },
  methods: {
    handleClick() {
      this.$emit("click")
    }
  }
}
</script>
